module.exports = __webpack_public_path__ + "img/4.5cff5585.png";